import React from 'react';
import './loadingOverlay.scss';
import HesSpinner from './hesSpinner';

function loadingOverlay(props) {
  return (
    <div className="overlayContainer">
      <div className="d-flex flex-row overlayContent">
        <HesSpinner />      
        <div className="ms-5">{props.messageText ?? 'Loading, please wait'}</div>
      </div>
    </div>
  );
}

export default loadingOverlay;
